import { render } from "./Layout5.vue?vue&type=template&id=45e25bd5&ts=true"
import script from "./Layout5.vue?vue&type=script&lang=ts"
export * from "./Layout5.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__